import { render, staticRenderFns } from "./SearchHistory.vue?vue&type=template&id=44dac07e&lang=pug&"
import script from "./SearchHistory.vue?vue&type=script&lang=js&"
export * from "./SearchHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports